module.exports = __webpack_public_path__ + "qa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/qa.svg
// module id = 1031
// module chunks = 0